<template>
  <svg xmlns:svg="http://www.w3.org/2000/svg" style="z-index: 2" xmlns="http://www.w3.org/2000/svg" version="1.1"
    width="100%" height="100%" preserveAspectRatio="none" id="state_interpreter">
    <rect x="0" y="0" width="100%" height="100%" stroke="gray" stroke-width="1" :fill="fill" class="interpreter"></rect>
    <text id="heading_caption" :x="getX()" y="70%" :text-anchor="text_anchor"
      :class="{ 'f-editor': true, unselectable: $store.getters.editMode }" :font-weight="fontStyle">
      {{ PropertyURI ? level_value : heading_caption }}
      <title> {{ PropertyURI ? level_value : heading_caption }}{{ hint }}</title>
    </text>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "editor",
  mixins: [MixinStates],
  props: {
    heading_caption: {
      default: "",
    },
    text_anchor: {
      type: String,
      default: "start",
    },
    fill: {
      type: String,
      default: "black",
    },
  },
  computed: {
    value: function () {
      if (typeof this.properties[this.PropertyURI] == "undefined") {
        return null;
      } else {
        return this.properties[this.PropertyURI].outputValue.value;
      }
    },
    level_value: function () {
      return this.round &&
        this.value !== null &&
        this.value !== undefined &&
        !isNaN(this.value)
        ? this.value.toFixed(this.round)
        : this.value;
    },
  },
  methods: {
    getX() {
      switch (this.text_anchor) {
        case "end":
          return "98%";
        case "middle":
          return "49%";
        default:
          return "3%";
      }
    },
  },
};
</script>
<style scoped>
.f-editor {
  font-family: var(--font-family);
}
</style>
